import script from "./LoadBarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadBarButton.vue?vue&type=script&setup=true&lang=js"

import "./LoadBarButton.vue?vue&type=style&index=0&id=7b8061de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8061de"]])

export default __exports__